export default __webpack_public_path__ + "static/media/credit-card.d1af7674.svg";